// deVentura Theme - Global JavaScript

document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initCartDrawer();
  // En la página de colección los descuentos los gestiona collection.liquid; no ejecutar refreshProductCardPrices para evitar add/remove al carrito y errores 400/409
  if (!document.getElementById('collection-product-grid')) {
    refreshProductCardPrices();
    setTimeout(refreshProductCardPrices, 200);
    setTimeout(refreshProductCardPrices, 350);
    setTimeout(refreshProductCardPrices, 900);
    setTimeout(refreshProductCardPrices, 1800);
  }

  var qtyStyle = document.createElement('style');
  qtyStyle.textContent =
    'input.cart-qty-input::-webkit-inner-spin-button,' +
    'input.cart-qty-input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}' +
    'input.cart-qty-input{-moz-appearance:textfield}' +
    'input.cart-qty-input:focus{outline:1px solid var(--color-primary,#b8860b);border-radius:2px}' +
    '@media(min-width:768px){.lb-grid{grid-template-columns:1fr 1fr !important}}' +
    '@keyframes stockNotifIn{from{opacity:0;transform:translateY(-0.75rem)}to{opacity:1;transform:translateY(0)}}' +
    '@keyframes stockNotifOut{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(-0.75rem)}}' +
    '.product-price-loading .product-price-skeleton{animation:productPricePulse 1s ease-in-out infinite}' +
    '@keyframes productPricePulse{0%,100%{opacity:0.5}50%{opacity:1}}';
  document.head.appendChild(qtyStyle);
});

// ===== Mobile Menu =====
function initMobileMenu() {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuDrawer = document.querySelector('[data-menu-drawer]');
  const menuClose = document.querySelector('[data-menu-close]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');

  if (!menuToggle || !menuDrawer) return;

  menuToggle.addEventListener('click', function () {
    menuDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  function closeMenu() {
    menuDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuDrawer.classList.contains('is-open')) {
      closeMenu();
    }
  });
}

// ===== Cart Drawer =====
function initCartDrawer() {
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');

  if (!cartToggle || !cartDrawer) return;

  cartToggle.addEventListener('click', function () {
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  });

  function closeCart() {
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
      closeCart();
    }
  });
}

// ===== Stock Notification (global) =====
function showCartNotification(message, type) {
  var existing = document.getElementById('cart-stock-notification');
  if (existing) existing.remove();

  var el = document.createElement('div');
  el.id = 'cart-stock-notification';
  el.setAttribute('role', 'alert');

  var isError = (type === 'error');
  var bg = isError ? '#fee2e2' : '#fef3cd';
  var clr = isError ? '#991b1b' : '#856404';
  var brd = isError ? '#f87171' : '#ffc107';

  el.innerHTML =
    '<div style="display:flex;align-items:center;gap:0.65rem;background:' + bg +
    ';color:' + clr + ';border:1px solid ' + brd +
    ';border-radius:0.375rem;padding:0.85rem 1.15rem;font-family:var(--font-body,sans-serif);font-size:0.875rem;line-height:1.4;box-shadow:0 4px 16px rgba(0,0,0,0.10);max-width:22rem">' +
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0">' +
    '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
    '<span>' + message + '</span>' +
    '<button onclick="this.parentElement.parentElement.remove()" style="background:none;border:none;color:inherit;cursor:pointer;padding:0;margin-left:auto;flex-shrink:0;opacity:0.7">' +
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
    '</button></div>';

  el.style.cssText = 'position:fixed;top:1.5rem;right:1.5rem;z-index:10010;animation:stockNotifIn 0.35s ease-out';
  document.body.appendChild(el);

  setTimeout(function () {
    if (el.parentElement) {
      el.style.animation = 'stockNotifOut 0.35s ease-in forwards';
      setTimeout(function () { if (el.parentElement) el.remove(); }, 400);
    }
  }, 4000);
}

// ===== Translate Shopify cart error messages =====
function translateCartError(msg) {
  if (!msg || typeof msg !== 'string') return 'No se pudo actualizar el carrito. Intenta de nuevo.';
  msg = msg.trim();
  if (!msg) return 'No se pudo actualizar el carrito. Intenta de nuevo.';
  var match = msg.match(/Only (\d+) items? (?:were|was) added/i);
  if (match) return 'Solo se pudieron a\u00F1adir ' + match[1] + ' unidades debido al stock disponible';
  match = msg.match(/You can only add (\d+) .* to the cart/i);
  if (match) return 'Solo puedes a\u00F1adir ' + match[1] + ' unidades al carrito';
  match = msg.match(/Cart Error/i);
  if (match) return 'No hay suficiente stock disponible';
  if (/not enough|out of stock|unavailable|availability/i.test(msg)) return 'No hay suficiente stock disponible';
  if (/invalid|unprocessable|identificaci\u00F3n|par\u00E1metro lineal no v\u00E1lido/i.test(msg)) return 'El carrito ha cambiado. Se ha actualizado la p\u00E1gina.';
  if (/stock|cantidad m\u00E1xima|maximum quantity/i.test(msg)) return 'No hay suficiente stock disponible';
  return msg;
}

// ===== Format money =====
function formatCartMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
}

function formatPriceHtml(price, compareAtPrice) {
  if (compareAtPrice && compareAtPrice > price) {
    var pct = Math.round((1 - price / compareAtPrice) * 100);
    return '<span style="text-decoration:line-through;color:var(--color-muted-foreground,#999);font-weight:400;font-size:0.85em;margin-right:0.4rem">' +
      formatCartMoney(compareAtPrice) + '</span>' +
      '<span style="color:var(--color-primary,#b8860b)">' + formatCartMoney(price) + '</span>' +
      '<span style="color:#b91c1c;font-size:0.75em;font-weight:600;margin-left:0.4rem;letter-spacing:0.02em">-' + pct + '%</span>';
  }
  return '<span style="color:var(--color-primary,#b8860b)">' + formatCartMoney(price) + '</span>';
}

function formatCartItemPriceHtml(item) {
  var hasLineDiscount = item.original_price && item.original_price > item.final_price;
  var compareAt = item.compare_at_price;
  if (compareAt == null && window.__CART_VARIANT_COMPARE_AT__ && item.variant_id != null) {
    var fromMap = window.__CART_VARIANT_COMPARE_AT__[String(item.variant_id)];
    if (fromMap != null && fromMap > 0) compareAt = fromMap;
  }
  var hasCompareAt = compareAt && compareAt > item.final_price;
  var basePrice = hasCompareAt ? compareAt : item.original_price;

  if (!hasLineDiscount && !hasCompareAt) {
    return '<span style="color:var(--color-primary,#b8860b)">' + formatCartMoney(item.final_price) + '</span>';
  }

  var html = '';
  if (hasCompareAt) {
    html += '<span style="text-decoration:line-through;color:var(--color-muted-foreground,#999);font-weight:400;font-size:0.85em;margin-right:0.35rem">' + formatCartMoney(compareAt) + '</span>';
  }
  if (hasLineDiscount && (!hasCompareAt || item.original_price !== compareAt)) {
    html += '<span style="text-decoration:line-through;color:var(--color-muted-foreground,#999);font-weight:400;font-size:0.85em;margin-right:0.35rem">' + formatCartMoney(item.original_price) + '</span>';
  }
  if (basePrice > item.final_price) {
    var pct = Math.round((1 - item.final_price / basePrice) * 100);
    html += '<span style="color:var(--color-primary,#b8860b)">' + formatCartMoney(item.final_price) + '</span>';
    html += '<span style="color:#b91c1c;font-size:0.75em;font-weight:600;margin-left:0.35rem">-' + pct + '%</span>';
  }
  var allocations = item.discount_allocations || item.line_level_discount_allocations;
  if (hasLineDiscount && allocations && allocations.length > 0) {
    for (var d = 0; d < allocations.length; d++) {
      var da = allocations[d];
      var amount = da.amount != null ? da.amount : da.total_allocated_amount;
      html += '<br><span style="font-size:0.75em;color:#b91c1c;font-style:italic">' + '</span>';
    }
  }
  return html;
}

// ===== Auto-discount detection (cart preview) — solo lectura, no modifica el carrito; sin caché para reflejar siempre el carrito actual =====
var _discountCheckLock = false;

function buildDiscountInfoFromCartItem(item) {
  if (!item || !item.original_price || item.original_price <= item.final_price) return null;
  var discountInfo = {
    original_price: item.original_price,
    final_price: item.final_price,
    discount_title: '',
    discount_allocations: []
  };
  var allocs = item.discount_allocations || item.line_level_discount_allocations || [];
  for (var a = 0; a < allocs.length; a++) {
    var da = allocs[a];
    var t = (da.discount_application && da.discount_application.title) ? da.discount_application.title : (da.title || 'Descuento');
    var amt = da.amount != null ? da.amount : da.total_allocated_amount;
    if (t || amt != null) discountInfo.discount_allocations.push({ title: t || 'Descuento', amount: amt || 0 });
  }
  if (discountInfo.discount_allocations.length) discountInfo.discount_title = discountInfo.discount_allocations[0].title;
  return discountInfo;
}

function previewDiscountForVariant(variantId, callback) {
  if (!variantId || !callback) return;
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
    .then(function (res) { return res.json(); })
    .then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id == variantId) { item = cart.items[i]; break; }
      }
      var info = item ? buildDiscountInfoFromCartItem(item) : null;
      var keyToRemove = item ? item.key : null;
      if (!keyToRemove) { callback(info); return; }
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: keyToRemove, quantity: 0 }) })
        .then(function () { return callback(info); });
    })
    .catch(function () { callback(null); });
}

function refreshProductCardPrices() {
  if (document.getElementById('collection-product-grid')) return Promise.resolve();
  var cards = document.querySelectorAll('.product-card[data-variant-id], [data-variant-id].product-card');
  if (!cards.length) cards = document.querySelectorAll('[data-variant-id]');
  if (!cards.length) return Promise.resolve();

  function applyDiscountsToCards(cartItems) {
    if (!cartItems || !cartItems.length) return;
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var variantId = card.getAttribute('data-variant-id');
      if (!variantId) continue;
      var wrap = card.querySelector('.product-card-title-price') || card.querySelector('.product-card-price-wrap') || card.querySelector('[data-product-card-price]');
      if (!wrap) continue;
      var item = null;
      for (var i = 0; i < cartItems.length; i++) {
        var vi = cartItems[i].variant_id;
        if (vi == variantId || String(vi) === String(variantId)) {
          item = cartItems[i];
          break;
        }
      }
      if (!item || !item.original_price || item.original_price <= item.final_price) continue;
      var discountInfo = buildDiscountInfoFromCartItem(item);
      if (!discountInfo) continue;
      var priceHtml = typeof formatAutoDiscountHtml === 'function'
        ? formatAutoDiscountHtml(item.original_price, discountInfo)
        : ('<span style="color:var(--color-primary,#b8860b)">' + (typeof formatCartMoney === 'function' ? formatCartMoney(item.final_price) : (item.final_price / 100).toFixed(2) + ' €') + '</span>');
      var titleEl = wrap.querySelector('.product-card__title, .title');
      var sepEl = wrap.querySelector('.mx-2, .separator');
      var titleHtml = titleEl ? titleEl.outerHTML : '<span class="title" style="font-weight:500;color:var(--color-foreground)">' + (card.querySelector('.product-card__title, .title') ? card.querySelector('.product-card__title, .title').textContent : '') + '</span>';
      var sepHtml = sepEl ? sepEl.outerHTML : '<span class="separator" style="margin:0 0.5rem;color:var(--color-muted-foreground)">–</span>';
      wrap.innerHTML = titleHtml + sepHtml + '<span class="price" style="color:var(--color-primary);font-family:var(--font-body);font-size:0.875rem">' + priceHtml + '</span>';
    }
  }

  var existingIds = {};
  if (typeof window.__COLLECTION_CART_ITEMS__ !== 'undefined' && Array.isArray(window.__COLLECTION_CART_ITEMS__)) {
    for (var e = 0; e < window.__COLLECTION_CART_ITEMS__.length; e++) {
      existingIds[String(window.__COLLECTION_CART_ITEMS__[e].variant_id)] = true;
    }
    applyDiscountsToCards(window.__COLLECTION_CART_ITEMS__);
  }

  var variantIdsToPreview = [];
  for (var v = 0; v < cards.length; v++) {
    var vid = cards[v].getAttribute('data-variant-id');
    if (vid && !existingIds[String(vid)]) variantIdsToPreview.push(vid);
  }

  if (window.__COLLECTION_PREVIEW_CACHE__ && typeof window.__COLLECTION_PREVIEW_CACHE__ === 'object') {
    var cachedItems = [];
    for (var k in window.__COLLECTION_PREVIEW_CACHE__) {
      if (window.__COLLECTION_PREVIEW_CACHE__.hasOwnProperty(k)) {
        cachedItems.push(window.__COLLECTION_PREVIEW_CACHE__[k]);
        existingIds[k] = true;
      }
    }
    if (cachedItems.length) applyDiscountsToCards((window.__COLLECTION_CART_ITEMS__ || []).concat(cachedItems));
  }

  if (variantIdsToPreview.length === 0) return Promise.resolve();

  var maxPreview = Math.min(variantIdsToPreview.length, 12);
  return new Promise(function (resolve) {
    function addNext(index) {
      if (index >= maxPreview) {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          window.__COLLECTION_PREVIEW_CACHE__ = window.__COLLECTION_PREVIEW_CACHE__ || {};
          for (var i = 0; i < cart.items.length; i++) {
            for (var j = 0; j < maxPreview; j++) {
              if (String(cart.items[i].variant_id) === String(variantIdsToPreview[j])) {
                window.__COLLECTION_PREVIEW_CACHE__[String(cart.items[i].variant_id)] = cart.items[i];
                break;
              }
            }
          }
          applyDiscountsToCards(cart.items);
          var keysToRemove = [];
          for (var i = 0; i < cart.items.length; i++) {
            for (var j = 0; j < maxPreview; j++) {
              if (String(cart.items[i].variant_id) === String(variantIdsToPreview[j])) {
                keysToRemove.push(cart.items[i].key);
                break;
              }
            }
          }
          function removeNext(ri) {
            if (ri >= keysToRemove.length) {
              fetch('/cart.js').then(function (r) { return r.json(); }).then(function (updated) {
                if (typeof syncCartCount === 'function') syncCartCount(updated);
                resolve();
              }).catch(function () { resolve(); });
              return;
            }
            fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: keysToRemove[ri], quantity: 0 }) })
              .then(function () { removeNext(ri + 1); })
              .catch(function () { removeNext(ri + 1); });
          }
          removeNext(0);
        }).catch(function () { resolve(); });
        return;
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantIdsToPreview[index], quantity: 1 }) })
        .then(function () { addNext(index + 1); })
        .catch(function () { addNext(index + 1); });
    }
    addNext(0);
  });
}

function checkAutoDiscount(variantId, callback) {
  if (!variantId || !callback) return;

  if (_discountCheckLock) {
    setTimeout(function () { checkAutoDiscount(variantId, callback); }, 150);
    return;
  }

  _discountCheckLock = true;

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var info = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id == variantId) {
          var existing = cart.items[i];
          if (existing.original_price && existing.original_price > existing.final_price) {
            info = {
              original_price: existing.original_price,
              final_price: existing.final_price,
              discount_title: '',
              discount_allocations: []
            };
            var allocs = existing.discount_allocations || existing.line_level_discount_allocations || [];
            if (allocs.length > 0) {
              for (var a = 0; a < allocs.length; a++) {
                var da = allocs[a];
                var t = (da.discount_application && da.discount_application.title) ? da.discount_application.title : 'Descuento';
                var amt = da.amount != null ? da.amount : da.total_allocated_amount;
                info.discount_allocations.push({ title: t, amount: amt });
              }
              info.discount_title = info.discount_allocations[0].title;
            }
          }
          break;
        }
      }
      _discountCheckLock = false;
      callback(info);
    })
    .catch(function (err) {
      console.error('Auto-discount check error:', err);
      _discountCheckLock = false;
      callback(null);
    });
}

function formatAutoDiscountHtml(price, discountInfo) {
  if (!discountInfo) return formatPriceHtml(price, null);
  var orig = discountInfo.original_price;
  var final = discountInfo.final_price;
  var pct = Math.round((1 - final / orig) * 100);
  var html = '<span style="text-decoration:line-through;color:var(--color-muted-foreground,#999);font-weight:400;font-size:0.85em;margin-right:0.4rem">' +
    formatCartMoney(orig) + '</span>' +
    '<span style="color:var(--color-primary,#b8860b)">' + formatCartMoney(final) + '</span>' +
    '<span style="color:#b91c1c;font-size:0.75em;font-weight:600;margin-left:0.4rem;letter-spacing:0.02em">-' + pct + '%</span>';
  if (discountInfo.discount_allocations && discountInfo.discount_allocations.length > 0) {
    for (var i = 0; i < discountInfo.discount_allocations.length; i++) {
      var da = discountInfo.discount_allocations[i];
      html += '<br><span style="display:block;width:100%;font-size:0.75em;color:#b91c1c;font-style:italic">' + _esc(da.title) + ': -' + formatCartMoney(da.amount) + '</span>';
    }
  } else {
    var title = discountInfo.discount_title || 'Descuento autom\u00E1tico';
    html += '<br><span style="font-size:0.75em;color:#b91c1c;font-style:italic">' + title + '</span>';
  }
  return html;
}

// ===== Volume discount detection (quantity-based) — solo lectura, sin caché =====

function checkVolumeDiscount(variantId, callback) {
  if (!variantId || !callback) return;
  if (_discountCheckLock) {
    setTimeout(function () { checkVolumeDiscount(variantId, callback); }, 150);
    return;
  }
  _discountCheckLock = true;

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var result = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id == variantId) {
          var item = cart.items[i];
          if (item.original_price && item.original_price > item.final_price) {
            var dTitle = '';
            var allocs = item.discount_allocations || item.line_level_discount_allocations || [];
            if (allocs.length > 0) {
              dTitle = (allocs[0].discount_application && allocs[0].discount_application.title) || '';
            }
            result = {
              min_qty: item.quantity,
              original_price: item.original_price,
              final_price: item.final_price,
              discount_pct: Math.round((1 - item.final_price / item.original_price) * 100),
              discount_title: dTitle
            };
          }
          break;
        }
      }
      _discountCheckLock = false;
      callback(result);
    })
    .catch(function (err) {
      console.error('Volume discount check error:', err);
      _discountCheckLock = false;
      callback(null);
    });
}

function formatVolumeDiscountHtml(info) {
  if (!info) return '';
  var title = info.discount_title || 'Descuento por cantidad';
  var html = '<div style="margin-top:0.5rem;padding:0.6rem 0.85rem;border-radius:0.375rem;border:1px dashed #b91c1c;' +
    'font-family:var(--font-body,sans-serif);font-size:0.8rem;color:#b91c1c;line-height:1.4">' +
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display:inline;vertical-align:-2px;margin-right:0.35rem">' +
    '<path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
    '<strong>Compra ' + info.min_qty + ' o m\u00E1s</strong> y ahorra un <strong>' + info.discount_pct + '%</strong>' +
    ' <span style="opacity:0.7">\u00B7 ' + title + '</span>' +
    '</div>';
  return html;
}

// ===== Update Cart Count =====
function syncCartCount(cart) {
  var els = document.querySelectorAll('[data-cart-count]');
  for (var i = 0; i < els.length; i++) {
    els[i].textContent = cart.item_count;
    els[i].style.display = cart.item_count > 0 ? 'flex' : 'none';
  }
}

// ===== Render Cart Drawer from cart object =====
function renderCartDrawer(cart) {
  var container = document.querySelector('[data-cart-content]');
  if (!container) return;

  if (!cart.items || cart.items.length === 0) {
    container.innerHTML =
      '<div class="cart-drawer__empty">' +
      '<svg style="width:3rem;height:3rem;color:var(--color-muted-foreground);margin-bottom:1rem" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
      '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/></svg>' +
      '<p class="text-muted font-sans">Tu carrito est\u00E1 vac\u00EDo</p></div>';
    return;
  }

  var html = '<div class="cart-drawer__items">';

  for (var i = 0; i < cart.items.length; i++) {
    var it = cart.items[i];

    var safeKey = String(it.key).replace(/'/g, "\\'").replace(/"/g, '&quot;');
    var safeTitle = String(it.product_title || it.title || '').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    var imgSrc = it.image || '';
    var imgTag = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + safeTitle + '" loading="lazy" width="100" height="100" style="width:100%;height:100%;object-fit:cover">'
      : '';

    var variantTag = '';
    if (it.variant_title && it.variant_title !== 'Default Title') {
      variantTag = '<p class="text-sm text-muted">' + it.variant_title + '</p>';
    }

    var itemUrl = (it.url || '/products/' + (it.handle || '')).replace(/"/g, '&quot;');

    html +=
      '<div class="cart-item">' +
      '<a href="' + itemUrl + '" class="cart-item__image" style="display:block;text-decoration:none">' + imgTag + '</a>' +
      '<a href="' + itemUrl + '" class="cart-item__details" style="text-decoration:none;color:inherit;display:block">' +
      '<h4>' + safeTitle + '</h4>' +
      variantTag +
      '<div class="font-medium" style="display:flex;align-items:center;flex-wrap:wrap;gap:0.2rem;font-size:0.85rem">' + formatCartItemPriceHtml(it) + '</div>' +
      '</a>' +
      '<div class="cart-item__actions">' +
      '<button class="icon-btn" onclick="stepCartQty(this,-1,\'' + safeKey + '\',\'' + safeTitle + '\')" aria-label="Reducir cantidad">' +
      '<svg class="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/></svg>' +
      '</button>' +
      '<input type="number" min="1" value="' + it.quantity + '" ' +
      'data-key="' + safeKey + '" data-name="' + safeTitle + '" ' +
      'onchange="handleQtyInput(this.dataset.key,this,this.dataset.name)" ' +
      'onkeydown="if(event.key===\'Enter\'){event.preventDefault();this.blur()}" ' +
      'aria-label="Cantidad" class="cart-qty-input cart-item__quantity" ' +
      'style="width:2.5rem;text-align:center;font-size:0.85rem;border:none;background:transparent;font-family:inherit;padding:0">' +
      '<button class="icon-btn" onclick="stepCartQty(this,+1,\'' + safeKey + '\',\'' + safeTitle + '\')" aria-label="Aumentar cantidad">' +
      '<svg class="icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>' +
      '</button>' +
      '<button class="cart-item__remove" data-key="' + safeKey + '" data-name="' + safeTitle + '" onclick="removeCartItem(this.dataset.key,this.dataset.name)" aria-label="Eliminar artículo">' +
      '<svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>' +
      '</button>' +
      '</div>' +
      '</div>';
  }

  html += '</div>';

  var drawerFooterHtml = '';
  var totalRefDrawer = 0;
  for (var dri = 0; dri < cart.items.length; dri++) {
    var itd = cart.items[dri];
    var compareAtD = itd.compare_at_price;
    if (compareAtD == null && typeof window.__CART_VARIANT_COMPARE_AT__ !== 'undefined' && window.__CART_VARIANT_COMPARE_AT__[String(itd.variant_id)] != null) {
      compareAtD = window.__CART_VARIANT_COMPARE_AT__[String(itd.variant_id)];
    }
    var lineRefD = (compareAtD && compareAtD > itd.final_price) ? (compareAtD * itd.quantity) : (itd.original_price * itd.quantity);
    totalRefDrawer += lineRefD;
  }
  var descuentoDrawer = totalRefDrawer - cart.total_price;
  var drawerHasDiscount = descuentoDrawer > 0;
  if (drawerHasDiscount) {
    drawerFooterHtml += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.3rem">' +
      '<span class="font-sans" style="font-size:0.85rem;color:var(--color-muted-foreground)">Subtotal</span>' +
      '<span class="font-sans" style="font-size:0.85rem;color:var(--color-muted-foreground)">' + formatCartMoney(totalRefDrawer) + '</span></div>';
    drawerFooterHtml += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.3rem">' +
      '<span class="font-sans" style="font-size:0.8rem;color:#b91c1c;font-weight:500">Descuento</span>' +
      '<span class="font-sans" style="font-size:0.8rem;color:#b91c1c;font-weight:500">-' + formatCartMoney(descuentoDrawer) + '</span></div>';
  }

  html +=
    '<div class="cart-drawer__footer">' +
    drawerFooterHtml +
    '<div class="cart-drawer__total">' +
    '<span class="font-medium text-lg">Total</span>' +
    '<span class="font-bold text-xl">' + formatCartMoney(cart.total_price) + '</span>' +
    '</div>' +
    '<a href="/cart" class="btn btn-primary" style="width:100%">' +
    '<svg style="width:1rem;height:1rem;margin-right:0.5rem" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
    '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/></svg>' +
    'Ver mi carrito</a>' +
    '</div>';

  container.innerHTML = html;
}

// ===== Render Cart Page (full /cart page) =====
function renderCartPage(cart) {
  var container = document.querySelector('[data-cart-page-content]');
  if (!container) return;

  if (!cart.items || cart.items.length === 0) {
    container.innerHTML =
      '<div style="text-align:center;padding:4rem 1rem;">' +
      '<svg style="width:3rem;height:3rem;color:var(--color-muted-foreground);margin:0 auto 1rem" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
      '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>' +
      '</svg>' +
      '<p class="text-muted font-sans mb-6">Tu carrito est\u00E1 vac\u00EDo</p>' +
        '<a href="/" class="btn btn-gold" style="display:inline-block;padding:0.75rem 2rem;">Seguir comprando</a>' +
      '</div>';
    return;
  }

  var html = '<form action="/cart" method="post" novalidate>' +
    '<div style="display:flex;flex-direction:column;gap:1rem;margin-bottom:2rem;">';

  for (var i = 0; i < cart.items.length; i++) {
    var it = cart.items[i];
    var safeKey = String(it.key).replace(/'/g, "\\'").replace(/"/g, '&quot;');
    var safeTitle = String(it.product_title || it.title || '').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    var imgSrc = it.image ? it.image.replace(/(\.[a-z]+)\?/, '_200x$1?') : '';
    var itemUrl = (it.url || '/products/' + (it.handle || '')).replace(/"/g, '&quot;');
    var imgTag = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + safeTitle + '" width="100" height="100" loading="lazy" style="width:100%;height:100%;object-fit:cover">'
      : '';
    var imageBlock = '<div style="width:5rem;height:5rem;overflow:hidden;border-radius:0.125rem;background:var(--color-cream)">' +
      '<a href="' + itemUrl + '" style="display:block;width:100%;height:100%">' + imgTag + '</a></div>';

    var variantTag = '';
    if (it.variant_title && it.variant_title !== 'Default Title') {
      variantTag = '<p class="text-sm text-muted">' + it.variant_title + '</p>';
    }

    html +=
      '<div class="cart-item" style="display:grid;grid-template-columns:5rem 1fr auto;gap:1rem;align-items:center;padding:1rem 0;border-bottom:1px solid var(--color-border);">' +
      imageBlock +
      '<div><a href="' + itemUrl + '" style="color:inherit;text-decoration:none;display:block">' +
      '<h4 class="font-sans font-medium" style="font-size:0.9rem;margin-bottom:0.25rem">' + safeTitle + '</h4>' +
      variantTag +
      '<div class="font-sans font-medium" style="font-size:0.875rem;margin-top:0.25rem;display:flex;align-items:center;flex-wrap:wrap;gap:0.25rem">' + formatCartItemPriceHtml(it) + '</div>' +
      '</a></div>' +
      '<div style="display:flex;align-items:center;gap:0.5rem;">' +
      '<div style="display:flex;align-items:center;gap:0.35rem;border:1px solid var(--color-border);border-radius:0.125rem;">' +
      '<button type="button" class="icon-btn" onclick="stepCartQty(this,-1,\'' + safeKey + '\',\'' + safeTitle + '\')" aria-label="Reducir cantidad" style="width:2rem;height:2rem;display:flex;align-items:center;justify-content:center;background:transparent;border:none;cursor:pointer;">' +
      '<svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/></svg>' +
      '</button>' +
      '<input type="number" min="1" value="' + it.quantity + '" ' +
      'data-key="' + safeKey + '" data-name="' + safeTitle + '" ' +
      'onchange="handleQtyInput(this.dataset.key,this,this.dataset.name)" ' +
      'onkeydown="if(event.key===\'Enter\'){event.preventDefault();this.blur()}" ' +
      'aria-label="Cantidad" class="cart-qty-input font-sans" ' +
      'style="width:2.5rem;text-align:center;font-size:0.85rem;border:none;background:transparent;font-family:inherit;padding:0">' +
      '<button type="button" class="icon-btn" onclick="stepCartQty(this,+1,\'' + safeKey + '\',\'' + safeTitle + '\')" aria-label="Aumentar cantidad" style="width:2rem;height:2rem;display:flex;align-items:center;justify-content:center;background:transparent;border:none;cursor:pointer;">' +
      '<svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>' +
      '</button>' +
      '</div>' +
      '<button type="button" class="cart-item__remove" data-key="' + safeKey + '" data-name="' + safeTitle + '" onclick="removeCartItem(this.dataset.key,this.dataset.name)" aria-label="Eliminar artículo">' +
      '<svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>' +
      '</button>' +
      '</div>' +
      '</div>';
  }

  var totalsHtml = '';
  var totalReferencia = 0;
  for (var ti = 0; ti < cart.items.length; ti++) {
    var it = cart.items[ti];
    var compareAt = it.compare_at_price;
    if (compareAt == null && typeof window.__CART_VARIANT_COMPARE_AT__ !== 'undefined' && window.__CART_VARIANT_COMPARE_AT__[String(it.variant_id)] != null) {
      compareAt = window.__CART_VARIANT_COMPARE_AT__[String(it.variant_id)];
    }
    var lineRef = (compareAt && compareAt > it.final_price) ? (compareAt * it.quantity) : (it.original_price * it.quantity);
    totalReferencia += lineRef;
  }
  var descuentoTotalConCompare = totalReferencia - cart.total_price;
  var hasDiscount = descuentoTotalConCompare > 0 || (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);
  if (hasDiscount) {
    totalsHtml += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.35rem;">' +
      '<span class="font-sans" style="font-size:0.9rem;color:var(--color-muted-foreground)">Subtotal</span>' +
      '<span class="font-sans" style="font-size:0.9rem;color:var(--color-muted-foreground)">' + formatCartMoney(totalReferencia) + '</span></div>';
    if (cart.cart_level_discount_applications) {
      for (var di = 0; di < cart.cart_level_discount_applications.length; di++) {
        var disc = cart.cart_level_discount_applications[di];
        totalsHtml += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.35rem;">' +
          '<span class="font-sans" style="font-size:0.85rem;color:#b91c1c">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display:inline;vertical-align:-1px;margin-right:0.25rem"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
          disc.title + '</span>' +
          '<span class="font-sans font-medium" style="font-size:0.85rem;color:#b91c1c">-' + formatCartMoney(disc.total_allocated_amount) + '</span></div>';
      }
    }
    if (descuentoTotalConCompare > 0) {
      totalsHtml += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.5rem;">' +
        '<span class="font-sans" style="font-size:0.85rem;color:#b91c1c;font-weight:500">Descuento total</span>' +
        '<span class="font-sans font-medium" style="font-size:0.85rem;color:#b91c1c">-' + formatCartMoney(descuentoTotalConCompare) + '</span></div>';
    }
    totalsHtml += '<div style="border-top:1px solid var(--color-border);padding-top:0.5rem;display:flex;justify-content:space-between;align-items:center;margin-bottom:0.5rem;">';
  } else {
    totalsHtml += '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0.5rem;">';
  }
  totalsHtml += '<span class="font-sans font-medium" style="font-size:1.1rem;">Total</span>' +
    '<span class="font-sans font-bold" style="font-size:1.25rem;">' + formatCartMoney(cart.total_price) + '</span></div>';

  html += '</div>' +
    '<div style="border-top:2px solid var(--color-foreground);padding-top:1.5rem;">' +
    totalsHtml +
    '<p class="text-muted font-sans" style="font-size:0.75rem;margin-bottom:1.5rem;">Impuestos y gastos de env\u00EDo calculados en el pago</p>' +
    '<div style="display:flex;flex-direction:column;gap:0.75rem;">' +
    '<button type="submit" name="checkout" class="btn btn-gold" style="width:100%;padding:1rem 2rem;">Finalizar pedido</button>' +
    '<a href="/" class="btn" style="width:100%;padding:0.75rem 2rem;text-align:center;border:1px solid var(--color-border);background:transparent;text-decoration:none;color:inherit;">Seguir comprando</a>' +
    '</div>' +
    '</div>' +
    '</form>';

  container.innerHTML = html;
}

// ===== Refresh Cart Drawer =====
function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      syncCartCount(cart);
      renderCartDrawer(cart);
      renderCartPage(cart);
    })
    .catch(function (err) {
      console.error('Error refreshing cart:', err);
    });
}

// ===== Refresh cart and force Shopify to recalculate (detect expired/removed offers) =====
// Call on cart page load and when opening drawer so prices reflect current offers.
function refreshCartWithRecalc() {
  return fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        syncCartCount(cart);
        renderCartDrawer(cart);
        renderCartPage(cart);
        return Promise.resolve({ cart: cart, totalChanged: false });
      }
      var updates = {};
      for (var i = 0; i < cart.items.length; i++) {
        var vid = cart.items[i].variant_id;
        var qty = cart.items[i].quantity;
        updates[vid] = (updates[vid] || 0) + qty;
      }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (updatedCart) {
          syncCartCount(updatedCart);
          renderCartDrawer(updatedCart);
          renderCartPage(updatedCart);
          return { cart: updatedCart, previousTotal: cart.total_price };
        });
    })
    .catch(function (err) {
      console.error('Error refreshing cart:', err);
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        syncCartCount(cart);
        renderCartDrawer(cart);
        renderCartPage(cart);
        return { cart: cart, totalChanged: false };
      });
    });
}

// ===== Open Cart Drawer helper =====
function openCartDrawer() {
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
}

// ===== Wait for discount check lock =====
function _waitForDiscountLock(fn) {
  if (!_discountCheckLock) { fn(); return; }
  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    if (!_discountCheckLock || attempts > 30) {
      clearInterval(timer);
      fn();
    }
  }, 100);
}

// ===== Add to Cart (AJAX) =====
function addToCart(variantId, quantity, stock, trackedBy, policy, compareAtPrice) {
  _waitForDiscountLock(function () { _addToCartInner(variantId, quantity, stock, trackedBy, policy, compareAtPrice); });
}
function _addToCartInner(variantId, quantity, stock, trackedBy, policy, compareAtPrice) {
  if (!quantity) quantity = 1;
  stock = parseInt(stock, 10);
  var preCheck = !isNaN(stock) && stock >= 0 && trackedBy && policy === 'deny';

  if (preCheck) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var currentQty = 0;
        var productName = '';
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id == variantId) {
            currentQty = cart.items[i].quantity;
            productName = cart.items[i].product_title || cart.items[i].title;
            break;
          }
        }
        if (currentQty >= stock) {
          showCartNotification(
            (productName ? '<strong>' + productName + '</strong>: ' : '') +
            'ya tienes el m\u00E1ximo disponible (<strong>' + stock + '</strong> uds.) en tu carrito'
          );
          openCartDrawer();
          syncCartCount(cart);
          renderCartDrawer(cart);
          renderCartPage(cart);
          return;
        }
        var canAdd = Math.min(quantity, stock - currentQty);
        var capped = canAdd < quantity;
        _doAddToCart(variantId, canAdd, capped ? (productName || null) : null, capped ? stock : null, compareAtPrice);
      })
      .catch(function () { _doAddToCart(variantId, quantity, null, null, compareAtPrice); });
  } else {
    _doAddToCart(variantId, quantity, null, null, compareAtPrice);
  }
}

function _doAddToCart(variantId, quantity, cappedName, cappedMax, compareAtPrice) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return null; }).then(function (errData) {
          if (response.status === 422 && errData) {
            adjustToMaxStock(variantId, errData);
          } else {
            showCartNotification('Error al a\u00F1adir al carrito', 'error');
            refreshCartDrawer();
          }
          return null;
        });
      }
      return response.json();
    })
    .then(function (data) {
      if (!data) return;
      if (compareAtPrice != null && compareAtPrice > 0) {
        window.__CART_VARIANT_COMPARE_AT__ = window.__CART_VARIANT_COMPARE_AT__ || {};
        window.__CART_VARIANT_COMPARE_AT__[String(variantId)] = compareAtPrice;
      }
      if (cappedName !== null && cappedMax !== null) {
        showCartNotification(
          '<strong>' + cappedName + '</strong>: se a\u00F1adi\u00F3 hasta el m\u00E1ximo disponible (<strong>' + cappedMax + '</strong> uds.)'
        );
      }
      openCartDrawer();
      refreshCartDrawer();
    })
    .catch(function (err) {
      console.error('Add to cart error:', err);
      showCartNotification('Error al a\u00F1adir al carrito', 'error');
    });
}

// ===== Auto-adjust to max stock on add error (fallback for 422) =====
// Shopify: "You can only add X" → X = unidades RESTANTES que se pueden añadir
// target total = currentQty + X
function adjustToMaxStock(variantId, errData) {
  var msg = errData.description || errData.message || '';
  var remaining = null;
  var allMatch = msg.match(/All\s+(\d+)\s+available/i);
  var addMatch = msg.match(/You can only add\s+(\d+)/i) || msg.match(/Only\s+(\d+)/i);

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var currentQty = 0;
      var productName = '';
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id == variantId) {
          currentQty = cart.items[i].quantity;
          productName = cart.items[i].product_title || cart.items[i].title;
          break;
        }
      }

      var totalTarget;
      if (allMatch) {
        // "All X available" → total stock = X, Shopify may have already added up to X
        totalTarget = parseInt(allMatch[1], 10);
      } else if (addMatch) {
        // "You can only add X more" → remaining = X → total = currentQty + X
        remaining = parseInt(addMatch[1], 10);
        totalTarget = currentQty + remaining;
      } else {
        showCartNotification(translateCartError(msg), 'error');
        openCartDrawer();
        syncCartCount(cart);
        renderCartDrawer(cart);
        renderCartPage(cart);
        return;
      }

      if (totalTarget <= currentQty) {
        showCartNotification(
          (productName ? '<strong>' + productName + '</strong>: ' : '') +
          'ya tienes el m\u00E1ximo disponible (<strong>' + currentQty + '</strong> uds.) en tu carrito'
        );
        openCartDrawer();
        syncCartCount(cart);
        renderCartDrawer(cart);
        renderCartPage(cart);
        return;
      }

      var updates = {};
      updates[variantId] = totalTarget;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (updatedCart) {
          showCartNotification(
            (productName ? '<strong>' + productName + '</strong>: ' : '') +
            'se ajust\u00F3 al m\u00E1ximo disponible (<strong>' + totalTarget + '</strong> uds.)'
          );
          openCartDrawer();
          syncCartCount(updatedCart);
          renderCartDrawer(updatedCart);
          renderCartPage(updatedCart);
        });
    })
    .catch(function () {
      showCartNotification(translateCartError(msg), 'error');
      refreshCartDrawer();
    });
}

// ===== Step Cart Quantity (+/- buttons with debounce) =====
var _stepDebounce = {};

function setCartItemControlsEnabled(cartItemRow, enabled) {
  if (!cartItemRow) return;
  var controls = cartItemRow.querySelectorAll('button.icon-btn, .cart-qty-input');
  for (var c = 0; c < controls.length; c++) {
    controls[c].disabled = !enabled;
    controls[c].style.pointerEvents = enabled ? '' : 'none';
    controls[c].style.opacity = enabled ? '' : '0.6';
  }
}

function stepCartQty(btn, delta, key, name) {
  var parent = btn.parentElement;
  var input = parent && parent.querySelector('.cart-qty-input');
  if (!input) return;

  var row = parent.closest('.cart-item') || parent;

  var current = parseInt(input.value, 10);
  if (isNaN(current)) current = 1;
  var next = current + delta;

  if (next <= 0) {
    removeCartItem(key, name);
    return;
  }

  input.value = next;

  clearTimeout(_stepDebounce[key]);
  _stepDebounce[key] = setTimeout(function () {
    delete _stepDebounce[key];
    setCartItemControlsEnabled(row, false);
    _waitForDiscountLock(function () { updateCartItem(key, next, name); });
  }, 400);
}

// ===== Handle Quantity Input (keyboard editable) =====
function handleQtyInput(key, inputEl, productName) {
  clearTimeout(_stepDebounce[key]);
  delete _stepDebounce[key];
  var desired = parseInt(inputEl.value, 10);
  if (isNaN(desired) || desired < 0) {
    refreshCartDrawer();
    return;
  }
  if (desired === 0) {
    removeCartItem(key, productName);
    return;
  }

  var row = inputEl.closest('.cart-item');
  setCartItemControlsEnabled(row, false);

  _waitForDiscountLock(function () {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: desired })
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          showCartNotification(translateCartError(data.description || data.message), 'error');
          refreshCartDrawer();
          return;
        }
        var actualQty = 0;
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].key === key) {
            actualQty = data.items[i].quantity;
            break;
          }
        }
        if (actualQty > 0 && actualQty < desired) {
          showCartNotification(
            '<strong>' + productName + '</strong>: m\u00E1ximo disponible <strong>' + actualQty + '</strong> unidades'
          );
        }
        syncCartCount(data);
        renderCartDrawer(data);
        renderCartPage(data);
      });
    })
    .catch(function (err) {
      console.error('Qty input error:', err);
      showCartNotification('Error al actualizar la cantidad', 'error');
      refreshCartDrawer();
    });
  });
}

// ===== Update Cart Item Quantity =====
function updateCartItem(key, quantity, productName) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
    .then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        try {
          data = text ? JSON.parse(text) : {};
        } catch (e) {
          data = {};
        }
        if (!response.ok) {
          var msg = (data && (data.description || data.message)) || text || '';
          showCartNotification(translateCartError(msg), 'error');
          refreshCartDrawer();
          return;
        }
        if (!data.items) {
          refreshCartDrawer();
          return;
        }
        var actualQty = 0;
        var itemName = productName || '';
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].key === key) {
            actualQty = data.items[i].quantity;
            itemName = data.items[i].product_title || data.items[i].title || itemName;
            break;
          }
        }
        if (quantity > 0 && actualQty > 0 && actualQty < quantity) {
          showCartNotification(
            'Se ha sobrepasado el stock' + (itemName ? ' de <strong>' + itemName + '</strong>' : '') +
            '. El stock m\u00E1ximo es <strong>' + actualQty + '</strong> unidades.',
            'error'
          );
        }
        syncCartCount(data);
        renderCartDrawer(data);
        renderCartPage(data);
      });
    })
    .catch(function (err) {
      console.error('Update cart error:', err);
      showCartNotification('Error al actualizar el carrito', 'error');
      refreshCartDrawer();
    });
}

// ===== Remove Cart Item (with confirmation modal) =====
var _pendingRemoveKey = null;

function removeCartItem(key, name) {
  _pendingRemoveKey = key;
  showRemoveConfirmModal(name || 'este art\u00EDculo');
}

function confirmRemoveCartItem() {
  var key = _pendingRemoveKey;
  closeRemoveConfirmModal();
  if (key) updateCartItem(key, 0);
}

function closeRemoveConfirmModal() {
  var overlay = document.getElementById('remove-confirm-modal');
  if (!overlay) return;
  overlay.style.opacity = '0';
  var card = overlay.querySelector('[data-modal-card]');
  if (card) {
    card.style.transition = 'transform 0.25s ease, opacity 0.25s ease';
    card.style.transform = 'translateY(12px) scale(0.97)';
    card.style.opacity = '0';
  }
  setTimeout(function () { if (overlay.parentElement) overlay.remove(); }, 280);
  document.body.style.overflow = '';
  _pendingRemoveKey = null;
  document.removeEventListener('keydown', _handleRemoveModalEsc);
}

function _handleRemoveModalEsc(e) {
  if (e.key === 'Escape') closeRemoveConfirmModal();
}

function showRemoveConfirmModal(productName) {
  var existing = document.getElementById('remove-confirm-modal');
  if (existing) existing.remove();

  if (!document.getElementById('remove-modal-styles')) {
    var styleEl = document.createElement('style');
    styleEl.id = 'remove-modal-styles';
    styleEl.textContent =
      '@keyframes rmIconPulse{0%{transform:scale(1)}50%{transform:scale(1.12)}100%{transform:scale(1)}}' +
      '@keyframes rmShimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}' +
      '@keyframes rmFadeUp{from{opacity:0;transform:translateY(12px) scale(0.97)}to{opacity:1;transform:translateY(0) scale(1)}}' +
      '.rm-cancel-btn:hover{background:#e4e4e4!important;border-color:#999!important}' +
      '.rm-delete-btn:hover{background:linear-gradient(135deg,#b91c1c,#991b1b)!important;box-shadow:0 6px 20px rgba(185,28,28,0.35)!important;transform:translateY(-1px)}' +
      '.rm-delete-btn:active{transform:translateY(0);box-shadow:0 2px 8px rgba(185,28,28,0.25)!important}';
    document.head.appendChild(styleEl);
  }

  var overlay = document.createElement('div');
  overlay.id = 'remove-confirm-modal';
  overlay.style.cssText = 'position:fixed;inset:0;z-index:10001;display:flex;align-items:center;justify-content:center;' +
    'background:rgba(0,0,0,0.25);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);opacity:0;transition:opacity 0.3s ease;padding:1rem';
  overlay.onclick = function (e) { if (e.target === overlay) closeRemoveConfirmModal(); };

  overlay.innerHTML =
    '<div data-modal-card style="background:#fff;border-radius:1rem;padding:2.25rem 2rem 2rem;max-width:22rem;width:100%;text-align:center;' +
    'box-shadow:0 25px 80px rgba(0,0,0,0.12),0 8px 24px rgba(0,0,0,0.08);' +
    'animation:rmFadeUp 0.35s cubic-bezier(0.34,1.56,0.64,1) forwards;font-family:var(--font-body,sans-serif);position:relative;overflow:hidden">' +

    '<div style="position:absolute;top:0;left:0;right:0;height:3px;' +
    'background:linear-gradient(90deg,transparent,#dc2626,#ef4444,#dc2626,transparent);' +
    'background-size:200% 100%;animation:rmShimmer 3s linear infinite"></div>' +

    '<div style="width:3.75rem;height:3.75rem;margin:0.5rem auto 1.25rem;border-radius:50%;display:flex;align-items:center;justify-content:center;' +
    'background:linear-gradient(135deg,#fef2f2,#fee2e2);border:1px solid #fecaca;animation:rmIconPulse 2s ease-in-out infinite">' +
    '<svg width="22" height="22" fill="none" stroke="#dc2626" viewBox="0 0 24 24" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' +
    '<polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>' +
    '<line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>' +
    '</div>' +

    '<h3 style="font-family:var(--font-heading,serif);font-size:1.2rem;font-weight:600;margin:0 0 0.65rem;color:var(--color-foreground,#1a1a1a);letter-spacing:-0.01em">' +
    '\u00BFEliminar del carrito?</h3>' +

    '<p style="font-size:0.85rem;color:var(--color-muted-foreground,#6b7280);margin:0 0 0.35rem;line-height:1.5">' +
    'Est\u00E1s a punto de eliminar</p>' +
    '<p style="font-size:0.9rem;color:var(--color-foreground,#1a1a1a);margin:0 0 1.75rem;line-height:1.5;font-weight:500;' +
    'background:var(--color-cream,#f9f6f2);border-radius:0.375rem;padding:0.5rem 0.85rem;display:inline-block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' +
    productName + '</p>' +

    '<div style="display:flex;gap:0.65rem">' +
    '<button onclick="closeRemoveConfirmModal()" class="rm-cancel-btn" style="flex:1;padding:0.75rem 1rem;border:1.5px solid #bbb;' +
    'background:#f0f0f0;border-radius:0.5rem;font-family:var(--font-body,sans-serif);font-size:0.85rem;cursor:pointer;' +
    'color:var(--color-foreground,#1a1a1a);transition:all 0.2s ease;font-weight:500">Cancelar</button>' +
    '<button onclick="confirmRemoveCartItem()" class="rm-delete-btn" style="flex:1;padding:0.75rem 1rem;border:none;' +
    'background:linear-gradient(135deg,#dc2626,#b91c1c);color:#fff;border-radius:0.5rem;font-family:var(--font-body,sans-serif);font-size:0.85rem;' +
    'cursor:pointer;transition:all 0.2s ease;font-weight:500;box-shadow:0 4px 14px rgba(220,38,38,0.25);display:flex;align-items:center;justify-content:center;gap:0.4rem">' +
    '<svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>' +
    'Eliminar</button>' +
    '</div>' +
    '</div>';

  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';

  requestAnimationFrame(function () {
    overlay.style.opacity = '1';
  });

  document.addEventListener('keydown', _handleRemoveModalEsc);
}

// ===== Stock Adjustment Banner (Cart Page) =====
function showStockAdjustmentNotification(adjustments) {
  var area = document.getElementById('stock-notification-area');
  if (!area) return;

  var html =
    '<div id="stock-adjustment-banner" style="' +
    'background:#fef3cd;color:#856404;border:1px solid #ffc107;border-radius:0.375rem;' +
    'padding:1rem 1.25rem;margin-bottom:1.5rem;font-family:var(--font-body,sans-serif);' +
    'font-size:0.875rem;line-height:1.6;animation:stockNotifIn 0.35s ease-out">' +
    '<div style="display:flex;align-items:flex-start;gap:0.65rem;">' +
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px">' +
    '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>' +
    '<line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
    '<div style="flex:1">' +
    '<strong style="display:block;margin-bottom:0.4rem;">Se han reajustado las cantidades por disponibilidad de stock:</strong>' +
    '<ul style="margin:0;padding-left:1.25rem;">';

  for (var i = 0; i < adjustments.length; i++) {
    var a = adjustments[i];
    html += '<li>' + a.name + ': <s>' + a.oldQty + '</s> \u2192 <strong>' + a.newQty + '</strong>' +
      (a.newQty === 0 ? ' (eliminado)' : '') + '</li>';
  }

  html +=
    '</ul></div>' +
    '<button onclick="this.closest(\'#stock-adjustment-banner\').remove()" ' +
    'style="background:none;border:none;color:inherit;cursor:pointer;padding:0;margin-left:auto;flex-shrink:0;opacity:0.7" aria-label="Cerrar">' +
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
    '</button>' +
    '</div></div>';

  area.innerHTML = html;
}

// ===== Product Lightbox =====
var _lightboxData = null;
var _lightboxSelected = {};

function openProductLightbox(cardEl) {
  var jsonEl = cardEl.querySelector('.product-card-data');
  if (!jsonEl) return;
  try { _lightboxData = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  _lightboxSelected = {};
  var opts = _lightboxData.options;
  if (Array.isArray(opts)) {
    for (var i = 0; i < opts.length; i++) {
      if (opts[i] && opts[i].name != null && opts[i].selected_value != null) {
        _lightboxSelected[opts[i].name] = opts[i].selected_value;
      }
    }
  }
  if (Object.keys(_lightboxSelected).length === 0 && _lightboxData.variants[0]) {
    var v0 = _lightboxData.variants[0];
    if (v0.option1) _lightboxSelected[opts[0] ? opts[0].name : 'Option1'] = v0.option1;
    if (v0.option2) _lightboxSelected[opts[1] ? opts[1].name : 'Option2'] = v0.option2;
    if (v0.option3) _lightboxSelected[opts[2] ? opts[2].name : 'Option3'] = v0.option3;
  }

  var d = _lightboxData;
  var variant = _getLbVariant();
  var imgs = d.images || [];
  var mainImg = imgs[0] || '';

  var imgHtml = '';
  if (mainImg) {
    imgHtml += '<img id="lb-main-img" src="' + mainImg + '" alt="' + _esc(d.title) + '" style="width:100%;height:100%;object-fit:cover">';
  }

  var thumbsHtml = '';
  if (imgs.length > 1) {
    thumbsHtml = '<div style="display:flex;gap:0.5rem;margin-top:0.75rem;overflow-x:auto;padding-bottom:0.25rem">';
    for (var t = 0; t < imgs.length; t++) {
      thumbsHtml += '<button type="button" onclick="document.getElementById(\'lb-main-img\').src=this.dataset.src" data-src="' + imgs[t] + '" ' +
        'style="width:3.5rem;height:3.5rem;flex-shrink:0;overflow:hidden;border:1px solid var(--color-border);border-radius:0.125rem;cursor:pointer;padding:0;background:none">' +
        '<img src="' + imgs[t] + '" alt="" style="width:100%;height:100%;object-fit:cover"></button>';
    }
    thumbsHtml += '</div>';
  }

  var typeHtml = '';
  if (d.type) {
    typeHtml = '<p style="font-family:var(--font-body);font-size:0.7rem;letter-spacing:0.2em;text-transform:uppercase;color:var(--color-muted-foreground,#999);margin-bottom:0.5rem">' + _esc(d.type).toUpperCase() + '</p>';
  }

  var priceVal = variant ? variant.price : (d.variants[0] ? d.variants[0].price : 0);
  var compareVal = variant ? variant.compare_at_price : (d.variants[0] ? d.variants[0].compare_at_price : null);
  var priceHtml = '<div id="lb-price" class="product-price-loading" style="font-family:var(--font-body);font-size:1.15rem;margin-bottom:0.75rem;display:flex;align-items:center;flex-wrap:wrap;gap:0.3rem;min-height:1.75rem"><span class="product-price-skeleton" style="display:inline-block;min-width:6rem;height:1.25rem;background:var(--color-border,#e5e7eb);border-radius:0.25rem;vertical-align:middle"></span></div>';
  var _lbInitialVariantId = variant ? variant.id : (d.variants[0] ? d.variants[0].id : null);

  var descHtml = '';
  if (d.description) {
    descHtml = '<div style="font-family:var(--font-body);font-size:0.8rem;color:var(--color-muted-foreground,#6b7280);line-height:1.6;margin-bottom:1.25rem;max-height:8rem;overflow-y:auto">' + _esc(d.description) + '</div>';
  }

  var variantsHtml = '';
  if (Array.isArray(opts) && opts.length > 0 && !(d.variants.length === 1 && d.variants[0].title === 'Default Title')) {
    for (var oi = 0; oi < opts.length; oi++) {
      var opt = opts[oi];
      if (!opt || !opt.values) continue;
      variantsHtml += '<div style="margin-bottom:1rem">' +
        '<label style="font-family:var(--font-body);font-size:0.7rem;letter-spacing:0.1em;text-transform:uppercase;color:var(--color-foreground,#1a1a1a);display:block;margin-bottom:0.5rem">' + _esc(opt.name) + '</label>' +
        '<div style="display:flex;flex-wrap:wrap;gap:0.4rem">';
      for (var vi = 0; vi < opt.values.length; vi++) {
        var val = opt.values[vi];
        var isSel = (_lightboxSelected[opt.name] === val);
        variantsHtml += '<button type="button" data-opt="' + _esc(opt.name) + '" data-val="' + _esc(val) + '" ' +
          'onclick="lbSelectVariant(this)" ' +
          'class="lb-var-btn' + (isSel ? ' lb-var-sel' : '') + '" ' +
          'style="padding:0.4rem 0.85rem;font-family:var(--font-body);font-size:0.8rem;border-radius:0.125rem;cursor:pointer;transition:all 0.2s ease;' +
          (isSel
            ? 'background:var(--color-foreground,#1a1a1a);color:var(--color-background,#fff);border:1px solid var(--color-foreground,#1a1a1a)'
            : 'background:transparent;color:inherit;border:1px solid var(--color-border,#d1d5db)') +
          '">' + _esc(val) + '</button>';
      }
      variantsHtml += '</div></div>';
    }
  }

  var isAvailable = variant ? variant.available : false;
  var qtyHtml =
    '<div style="display:flex;align-items:center;gap:0.5rem;margin-bottom:0.75rem">' +
      '<button type="button" onclick="lbStepQty(-1)" style="width:2.25rem;height:2.25rem;display:flex;align-items:center;justify-content:center;background:transparent;border:1px solid var(--color-border);border-radius:0.125rem;font-size:1.15rem;cursor:pointer">\u2212</button>' +
      '<input type="number" id="lb-qty" value="1" min="1" class="cart-qty-input" ' +
        'onchange="lbClampQty()" onkeydown="if(event.key===\'Enter\'){event.preventDefault();this.blur()}" ' +
        'style="width:3.5rem;height:2.25rem;text-align:center;font-family:var(--font-body);font-size:0.85rem;background:transparent;border:1px solid var(--color-border);border-radius:0.125rem;-moz-appearance:textfield">' +
      '<button type="button" onclick="lbStepQty(+1)" style="width:2.25rem;height:2.25rem;display:flex;align-items:center;justify-content:center;background:transparent;border:1px solid var(--color-border);border-radius:0.125rem;font-size:1.15rem;cursor:pointer">+</button>' +
    '</div>';

  var addBtnHtml = isAvailable
    ? '<button type="button" id="lb-add-btn" onclick="lbAddToCart()" class="btn btn-gold" style="width:100%;padding:0.85rem 2rem;margin-bottom:0.75rem">A\u00F1adir al carrito</button>'
    : '<button type="button" disabled class="btn btn-gold" style="width:100%;padding:0.85rem 2rem;margin-bottom:0.75rem;opacity:0.5;cursor:not-allowed">Agotado</button>';

  var linkHtml = '<a href="' + d.url + '" style="display:block;text-align:center;font-family:var(--font-body);font-size:0.8rem;color:var(--color-muted-foreground,#6b7280);text-decoration:underline;text-underline-offset:3px">Ver producto completo</a>';

  var stockInfoHtml = '<p id="lb-stock-info" style="font-family:var(--font-body);font-size:0.75rem;color:var(--color-text-muted,#999);margin-bottom:0.5rem;display:none"></p>';
  var lbVolBannerHtml = '<div id="lb-volume-banner"></div>';
  var lbVolDiscountInfoHtml = '<p id="lb-volume-discount-info" style="font-family:var(--font-body);font-size:0.75rem;color:var(--color-text-muted,#999);margin-bottom:0.5rem;display:none"></p>';

  var overlay = document.createElement('div');
  overlay.id = 'product-lightbox';
  overlay.style.cssText = 'position:fixed;inset:0;z-index:10001;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);opacity:0;transition:opacity 0.25s ease;padding:1rem;overflow-y:auto';
  overlay.onclick = function(e) { if (e.target === overlay) closeLightbox(); };

  overlay.innerHTML =
    '<div data-lb-card style="background:var(--color-background,#fff);border-radius:0.5rem;max-width:56rem;width:100%;max-height:90vh;overflow-y:auto;' +
      'box-shadow:0 25px 60px rgba(0,0,0,0.18);transform:scale(0.95);transition:transform 0.25s ease;position:relative">' +
      '<button onclick="closeLightbox()" style="position:absolute;top:0.75rem;right:0.75rem;background:none;border:none;cursor:pointer;z-index:2;padding:0.35rem;color:var(--color-foreground,#1a1a1a);opacity:0.6" aria-label="Cerrar">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<div class="lb-grid" style="display:grid;grid-template-columns:1fr;gap:1.5rem;padding:1.5rem">' +
        '<div>' +
          '<div style="aspect-ratio:1;overflow:hidden;border-radius:0.25rem;background:var(--color-cream,#f5f0eb)">' + imgHtml + '</div>' +
          thumbsHtml +
        '</div>' +
        '<div style="padding:0.5rem 0">' +
          typeHtml +
          '<h2 style="font-family:var(--font-heading,serif);font-size:1.5rem;font-weight:500;color:var(--color-foreground,#1a1a1a);margin:0 0 0.5rem">' + _esc(d.title) + '</h2>' +
          priceHtml +
          lbVolBannerHtml +
          lbVolDiscountInfoHtml +
          descHtml +
          variantsHtml +
          stockInfoHtml +
          qtyHtml +
          addBtnHtml +
          linkHtml +
        '</div>' +
      '</div>' +
    '</div>';

  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';

  requestAnimationFrame(function() {
    overlay.style.opacity = '1';
    var card = overlay.querySelector('[data-lb-card]');
    if (card) card.style.transform = 'scale(1)';
  });

  document.addEventListener('keydown', _lbEsc);
  _lbUpdateStockInfo();

  if (typeof checkAutoDiscount === 'function' && typeof formatAutoDiscountHtml === 'function' && _lbInitialVariantId) {
    var lbPriceEl = function() { return document.getElementById('lb-price'); };
    var setLbPrice = function(html) {
      var el = lbPriceEl();
      if (el) { el.innerHTML = html; el.classList.remove('product-price-loading'); }
    };
    checkAutoDiscount(_lbInitialVariantId, function(discountInfo) {
      if (discountInfo) {
        setLbPrice(formatAutoDiscountHtml(priceVal, discountInfo));
      } else if (typeof previewDiscountForVariant === 'function') {
        previewDiscountForVariant(_lbInitialVariantId, function(previewInfo) {
          setLbPrice(previewInfo ? formatAutoDiscountHtml(priceVal, previewInfo) : (typeof formatPriceHtml === 'function' ? formatPriceHtml(priceVal, compareVal) : ''));
        });
      } else {
        setLbPrice(typeof formatPriceHtml === 'function' ? formatPriceHtml(priceVal, compareVal) : '');
      }
    });
  } else if (_lbInitialVariantId == null && typeof formatPriceHtml === 'function') {
    var el = document.getElementById('lb-price');
    if (el) { el.innerHTML = formatPriceHtml(priceVal, compareVal); el.classList.remove('product-price-loading'); }
  }

  var _lbDefaultDiscountText = (d && d.oferta) ? String(d.oferta) : '';
  var _lbVolInfoEl = document.getElementById('lb-volume-discount-info');
  if (_lbVolInfoEl && _lbDefaultDiscountText) {
    _lbVolInfoEl.textContent = _lbDefaultDiscountText;
    _lbVolInfoEl.style.display = 'block';
  }
}

function closeLightbox() {
  var overlay = document.getElementById('product-lightbox');
  if (!overlay) return;
  overlay.style.opacity = '0';
  var card = overlay.querySelector('[data-lb-card]');
  if (card) card.style.transform = 'scale(0.95)';
  setTimeout(function() {
    if (overlay.parentElement) overlay.remove();
    if (typeof refreshProductCardPrices === 'function') refreshProductCardPrices();
  }, 250);
  document.body.style.overflow = '';
  _lightboxData = null;
  _lightboxSelected = {};
  document.removeEventListener('keydown', _lbEsc);
}

function _lbEsc(e) { if (e.key === 'Escape') closeLightbox(); }

function _esc(s) {
  if (!s) return '';
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function _getLbVariant() {
  if (!_lightboxData) return null;
  var keys = Object.keys(_lightboxSelected);
  var o1 = keys[0] ? _lightboxSelected[keys[0]] : null;
  var o2 = keys[1] ? _lightboxSelected[keys[1]] : null;
  var o3 = keys[2] ? _lightboxSelected[keys[2]] : null;
  for (var j = 0; j < _lightboxData.variants.length; j++) {
    var v = _lightboxData.variants[j];
    if ((!v.option1 || v.option1 === o1) && (!v.option2 || v.option2 === o2) && (!v.option3 || v.option3 === o3)) return v;
  }
  return null;
}

function lbSelectVariant(btn) {
  var optName = btn.dataset.opt;
  var optVal = btn.dataset.val;
  _lightboxSelected[optName] = optVal;

  var siblings = btn.parentElement.querySelectorAll('.lb-var-btn');
  for (var i = 0; i < siblings.length; i++) {
    siblings[i].classList.remove('lb-var-sel');
    siblings[i].style.background = 'transparent';
    siblings[i].style.color = 'inherit';
    siblings[i].style.borderColor = 'var(--color-border,#d1d5db)';
  }
  btn.classList.add('lb-var-sel');
  btn.style.background = 'var(--color-foreground,#1a1a1a)';
  btn.style.color = 'var(--color-background,#fff)';
  btn.style.borderColor = 'var(--color-foreground,#1a1a1a)';

  var variant = _getLbVariant();
  var priceEl = document.getElementById('lb-price');
  var lbVb = document.getElementById('lb-volume-banner');
  var lbVolInfo = document.getElementById('lb-volume-discount-info');
  var _lbDefaultDiscountText = (_lightboxData && _lightboxData.oferta) ? String(_lightboxData.oferta) : '';
  if (lbVb) lbVb.innerHTML = '';
  if (lbVolInfo) { lbVolInfo.textContent = _lbDefaultDiscountText; lbVolInfo.style.display = _lbDefaultDiscountText ? 'block' : 'none'; }
  if (priceEl && variant) {
    priceEl.classList.add('product-price-loading');
    priceEl.innerHTML = '<span class="product-price-skeleton" style="display:inline-block;min-width:6rem;height:1.25rem;background:var(--color-border,#e5e7eb);border-radius:0.25rem;vertical-align:middle"></span>';
    var setLbPrice = function(html) {
      var el = document.getElementById('lb-price');
      if (el) { el.innerHTML = html; el.classList.remove('product-price-loading'); }
    };
    if (typeof checkAutoDiscount === 'function' && typeof formatAutoDiscountHtml === 'function') {
      checkAutoDiscount(variant.id, function(discountInfo) {
        if (discountInfo) {
          setLbPrice(formatAutoDiscountHtml(variant.price, discountInfo));
        } else if (typeof previewDiscountForVariant === 'function') {
          previewDiscountForVariant(variant.id, function(previewInfo) {
            setLbPrice(previewInfo ? formatAutoDiscountHtml(variant.price, previewInfo) : (typeof formatPriceHtml === 'function' ? formatPriceHtml(variant.price, variant.compare_at_price) : ''));
          });
        } else {
          setLbPrice(typeof formatPriceHtml === 'function' ? formatPriceHtml(variant.price, variant.compare_at_price) : '');
        }
      });
    } else {
      setLbPrice(typeof formatPriceHtml === 'function' ? formatPriceHtml(variant.price, variant.compare_at_price) : '');
    }
  }

  var addBtn = document.getElementById('lb-add-btn');
  if (addBtn) {
    if (variant && variant.available) {
      addBtn.disabled = false;
      addBtn.style.opacity = '1';
      addBtn.style.cursor = 'pointer';
      addBtn.textContent = 'A\u00F1adir al carrito';
    } else {
      addBtn.disabled = true;
      addBtn.style.opacity = '0.5';
      addBtn.style.cursor = 'not-allowed';
      addBtn.textContent = 'Agotado';
    }
  }

  var qtyInput = document.getElementById('lb-qty');
  if (qtyInput) {
    var max = _getLbMaxStock();
    if (max !== null) {
      var cur = parseInt(qtyInput.value, 10) || 1;
      if (cur > max && max > 0) qtyInput.value = max;
      if (max <= 0) qtyInput.value = 1;
    }
  }
  _lbUpdateStockInfo();
}

function _getLbMaxStock() {
  var v = _getLbVariant();
  if (v && v.inventory_management && v.inventory_policy === 'deny') return v.inventory_quantity;
  return null;
}

function lbStepQty(delta) {
  var input = document.getElementById('lb-qty');
  if (!input) return;
  var cur = parseInt(input.value, 10) || 1;
  var next = cur + delta;
  if (next < 1) next = 1;
  var max = _getLbMaxStock();
  if (max !== null && next > max) {
    next = max > 0 ? max : 1;
    showCartNotification('M\u00E1ximo ' + max + ' unidades disponibles');
  }
  input.value = next;
}

function lbClampQty() {
  var input = document.getElementById('lb-qty');
  if (!input) return;
  var val = parseInt(input.value, 10);
  if (isNaN(val) || val < 1) { input.value = 1; return; }
  var max = _getLbMaxStock();
  if (max !== null && val > max) {
    input.value = max > 0 ? max : 1;
    showCartNotification('M\u00E1ximo ' + max + ' unidades disponibles');
  }
}

function _lbUpdateStockInfo() {
  var el = document.getElementById('lb-stock-info');
  if (!el) return;
  var v = _getLbVariant();
  if (!v || !v.inventory_management || v.inventory_policy !== 'deny') {
    el.style.display = 'none';
    return;
  }
  if (!v.available || v.inventory_quantity <= 0) {
    el.textContent = 'Sin stock disponible';
    el.style.display = 'block';
    el.style.color = 'var(--color-text-muted,#999)';
  } else if (v.inventory_quantity <= 5) {
    el.textContent = '\u00A1\u00DAltimas ' + v.inventory_quantity + ' unidades!';
    el.style.display = 'block';
    el.style.color = '#b45309';
  } else {
    el.textContent = 'En stock (' + v.inventory_quantity + ' disponibles)';
    el.style.display = 'block';
    el.style.color = 'var(--color-text-muted,#999)';
  }
}

function lbAddToCart() {
  var variant = _getLbVariant();
  if (!variant || !variant.available) return;
  var qtyInput = document.getElementById('lb-qty');
  var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
  var stock = variant.inventory_quantity;
  var tracked = variant.inventory_management;
  var policy = variant.inventory_policy;

  if (tracked && policy === 'deny') {
    if (stock <= 0) {
      showCartNotification('Este producto est\u00E1 agotado', 'error');
      return;
    }
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var currentQty = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id == variant.id) {
            currentQty = cart.items[i].quantity;
            break;
          }
        }
        if (currentQty >= stock) {
          showCartNotification(
            '<strong>' + _esc(_lightboxData.title) + '</strong>: ya tienes el m\u00E1ximo disponible (<strong>' + stock + '</strong> uds.) en tu carrito'
          );
          return;
        }
        var canAdd = Math.min(qty, stock - currentQty);
        if (canAdd < qty) {
          showCartNotification(
            'Solo se pueden a\u00F1adir ' + canAdd + ' uds. m\u00E1s (m\u00E1ximo de stock: ' + stock + ')'
          );
        }
        closeLightbox();
        addToCart(variant.id, canAdd, stock, tracked, policy, variant.compare_at_price || 0);
      })
      .catch(function() {
        closeLightbox();
        addToCart(variant.id, qty, stock, tracked, policy, variant.compare_at_price || 0);
      });
  } else {
    closeLightbox();
    addToCart(variant.id, qty, undefined, undefined, undefined, variant.compare_at_price || 0);
  }
}
